import { createAction, props } from '@ngrx/store';
import { Product } from 'graphql-api/gql-api-interfaces';

export const upsertProducts = createAction(
  '[Product entities] Upsert products',
  props<{
    products: Product[];
  }>(),
);
